import { render, staticRenderFns } from "./TeknikDestekDetay.vue?vue&type=template&id=7da4b32e&scoped=true&"
import script from "./TeknikDestekDetay.vue?vue&type=script&lang=js&"
export * from "./TeknikDestekDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da4b32e",
  null
  
)

export default component.exports